import { useLocation } from 'react-router-dom';
import { useMemo } from 'react';
import queryString from 'query-string';

const useQueryParams = () => {
  const { search } = useLocation();
  const queryParams = useMemo(() => queryString.parse(search), [search]);
  return queryParams;
};

export default useQueryParams;
